// Prijenos otvorenih stavaka u novu poslovnu godinu.
//
// Otvoreni iznos se uzima iz "/zatvaranja/stanje", koji spaja OBA nacina
// zatvaranja - prave veze iz "MainLedgerZatvaranja" i staro povezivanje preko
// broja racuna na uplati.
//
// Prije se prijenos racunao sam, grupiranjem po broju racuna
// (doZeros(invoiceOutNumber, BusinessYearInvoice)) i usporedbom duguje/potrazuje
// unutar te grupe. Taj nacin ne vidi nove veze: kod povezivanja 1:N stari broj
// se namjerno NE upisuje na uplatu, jer jedno polje ne moze izraziti vise veza.
// Takav bi se racun prenio u novu godinu kao otvoren iako je zatvoren, pa bi
// otvoreni saldo bio prenapuhan.
//
// Sada je izvor isti onaj koji korisnik vidi na ekranu za povezivanje, pa se
// prijenos i ekran ne mogu razici.
//
// Prenosi se OTVORENI iznos, ne cijeli dokument: djelomicno placen racun
// prelazi samo s ostatkom.

const n2 = (v) => Math.round(((parseFloat(v) || 0) + Number.EPSILON) * 100) / 100

// Na kontima kupaca (12xx) racun stoji na duguje, uplata na potrazuje.
// Na kontima dobavljaca (22xx) je obrnuto. Isto pravilo kao na posluzitelju.
const racunNaDuguje = (account4) => String(account4 || '').substring(0, 2) !== '22'

const BEZ_OIBA = '(bez OIB-a)'

/**
 * @param {Array} dokumenti  "dokumenti" iz /zatvaranja/stanje
 * @returns {{kartice: Array, ukupno: {Total1: number, Total2: number, Total5: number,
 *           partnera: number, stavaka: number}}}
 *
 * Kartice su u obliku koji ocekuje korak 2 zatvaranja godine i ekran
 * MainLedgerCard10: {partnerVATID, partnerName, detItems[], Total1, Total2, Total5}.
 */
export const zaPrijenos = (dokumenti) => {
  const otvoreni = (dokumenti || []).filter(d => n2(d.otvoreno) > 0.005)

  const po = new Map()
  otvoreni.forEach(d => {
    const konto = String(d.account4 || '')
    // Strana na koju otvoreni iznos ide u novoj godini je strana na kojoj
    // dokument i stoji: racun ostaje racun, nepovezana uplata ostaje uplata.
    const naDuguje = d.jeRacun ? racunNaDuguje(konto) : !racunNaDuguje(konto)
    const iznos = n2(d.otvoreno)

    const stavka = {
      ...d,
      account1: konto.substring(0, 1),
      account2: konto.substring(0, 2),
      account3: konto.substring(0, 3),
      account4: konto,
      Debit: naDuguje ? iznos : 0,
      Credit: naDuguje ? 0 : iznos,
      CreditDebit: naDuguje ? iznos : n2(-iznos),
      // Za prikaz na ekranu koraka 1.
      itBookName: d.BookName === 'BS' ? 'Izv.' : (d.BookName || ''),
      itInvoice: parseInt(d.invoiceInNumber) > 0
        ? parseInt(d.invoiceInNumber)
        : (parseInt(d.invoiceOutNumber) > 0 ? parseInt(d.invoiceOutNumber) : parseInt(d.BookID) || '')
    }

    const kljuc = d.partnerVATID || BEZ_OIBA
    if (!po.has(kljuc)) {
      po.set(kljuc, {
        partnerVATID: d.partnerVATID || '',
        partnerName: d.partnerName || '',
        detItems: [], Total1: 0, Total2: 0, Total5: 0
      })
    }
    const kartica = po.get(kljuc)
    if (!kartica.partnerName && d.partnerName) { kartica.partnerName = d.partnerName }
    kartica.detItems.push(stavka)
    kartica.Total1 = n2(kartica.Total1 + stavka.Debit)
    kartica.Total2 = n2(kartica.Total2 + stavka.Credit)
    kartica.Total5 = n2(kartica.Total1 - kartica.Total2)
  })

  const kartice = [...po.values()]
    .sort((a, b) => String(a.partnerName || '').localeCompare(String(b.partnerName || ''), 'hr'))
  kartice.forEach((k, i) => {
    k.id = i + 1
    k.itLine = i + 1
    // Redni broj unutar kartice; ekran ga koristi kao kljuc retka.
    k.detItems.forEach((s, j) => { s.subLine = j + 1; s.itBookName = (j + 1) + '. ' + s.itBookName })
  })

  const ukupno = kartice.reduce((z, k) => ({
    Total1: n2(z.Total1 + k.Total1),
    Total2: n2(z.Total2 + k.Total2),
    Total5: n2(z.Total5 + k.Total5),
    partnera: z.partnera + 1,
    stavaka: z.stavaka + k.detItems.length
  }), {Total1: 0, Total2: 0, Total5: 0, partnera: 0, stavaka: 0})

  return {kartice, ukupno}
}

export default zaPrijenos
